import axios from "axios";

const OWN_HOST = (h) => h === "jakeferree.com" || h.endsWith(".jakeferree.com") || h.endsWith(".emergent.host") || h.endsWith(".emergentagent.com");
export const BACKEND = typeof window !== "undefined" && OWN_HOST(window.location.hostname) ? "" : process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    const canRefresh = !url.startsWith("/auth/") || url === "/auth/me";
    if (err.response?.status === 401 && !cfg._retry && canRefresh) {
      cfg._retry = true;
      refreshing ??= api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch {
        /* fall through */
      }
    }
    return Promise.reject(err);
  }
);

export const NETWORK_MSG = "Can't reach the server. Check your connection and try again. If this address was just connected, it can take up to an hour to work everywhere.";

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  if (e?.isAxiosError && !e.response) return NETWORK_MSG;
  const d = e?.response?.data?.detail;
  if (!d) return e?.response?.status >= 500 ? "The server had a problem. Please try again in a minute." : fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || fallback;
  return d.msg || fallback;
};

export const download = async (path, filename) => {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = Object.assign(document.createElement("a"), { href: url, download: filename });
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
